import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import { USE_MOCK } from '@/config'
import { createClient } from '@/api/supabase'
import { useAuthStore } from '@/store/authStore'
import { useOrdersRealtime } from '@/hooks/useRealtime'
import { isPartner } from '@/utils/access'

function AuthSync() {
  const setProfile = useAuthStore((s) => s.setProfile)
  const profile = useAuthStore((s) => s.profile)

  useEffect(() => {
    if (USE_MOCK) return

    const supabase = createClient()

    // On startup: verify session is still valid; clear stale store if not
    supabase.auth.getSession().then(({ data }) => {
      if (!data.session && profile) {
        setProfile(null)
      }
    })

    // Keep store in sync with Supabase auth events
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event) => {
        if (event === 'SIGNED_OUT') {
          setProfile(null)
        }
      },
    )

    return () => subscription.unsubscribe()
    // Only run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

function OrdersRealtime() {
  useOrdersRealtime()
  return null
}

/** Realtime заказов — только рабочей консоли; партнёр таблиц не читает. */
function RealtimeSync() {
  const profile = useAuthStore((s) => s.profile)
  return isPartner(profile) ? null : <OrdersRealtime />
}

export default function App() {
  return (
    <>
      <AuthSync />
      <RealtimeSync />
      <RouterProvider router={router} />
    </>
  )
}
